import {
    faMicroscope,
    faDroplet,
    faSeedling,
    faTree,
    faLeaf,
    faBug,
    faCloud,
    faGripLines,
    faBugs,
    faStar,
    faPaw,
    faDove,
    faHandLizard,
    faFrog,
    faFish
} from '@fortawesome/free-solid-svg-icons';

export const categories = [
    { id: "Algae", label: "Thallophytes", subLabel: "Algae & Fungi", icon: faMicroscope, color: "#10b981", stats: { world: "72,500+", sl: "1,140", endemic: "185" } },
    { id: "Mosses", label: "Bryophytes", subLabel: "Mosses & Liverworts", icon: faDroplet, color: "#059669", stats: { world: "20,000+", sl: "560", endemic: "62" } },
    { id: "Ferns", label: "Pteridophytes", subLabel: "Ferns & Allies", icon: faSeedling, color: "#047857", stats: { world: "12,000+", sl: "348", endemic: "48" } },
    { id: "Conifers", label: "Gymnosperms", subLabel: "Conifers & Cycads", icon: faTree, color: "#065f46", stats: { world: "1,050", sl: "12", endemic: "0" } },
    { id: "Flowering", label: "Angiosperms", subLabel: "Flowering Plants", icon: faLeaf, color: "#f59e0b", stats: { world: "300,000+", sl: "3,154", endemic: "894" } },
    { id: "Insects", label: "Insects", subLabel: "Arthropodan Phylum", icon: faBug, color: "#d97706", stats: { world: "1M+", sl: "11,250", endemic: "2,140" } },
    { id: "Molluscs", label: "Molluscs", subLabel: "Soft-Bodied Inverts", icon: faCloud, color: "#2563eb", stats: { world: "85,000+", sl: "520", endemic: "214" } },
    { id: "Annelids", label: "Annelids", subLabel: "Segmented Worms", icon: faGripLines, color: "#4f46e5", stats: { world: "22,000+", sl: "145", endemic: "28" } },
    { id: "Arthropods", label: "Arthropods", subLabel: "Jointed Limbs", icon: faBugs, color: "#7c3aed", stats: { world: "7M+", sl: "15,000+", endemic: "3,200+" } },
    { id: "Echinoderms", label: "Echinoderms", subLabel: "Spiny-Skinned", icon: faStar, color: "#db2777", stats: { world: "7,000+", sl: "118", endemic: "0" } },
    { id: "Mammals", label: "Mammals", subLabel: "Warm-Blooded", icon: faPaw, color: "#ea580c", stats: { world: "5,450", sl: "124", endemic: "21" } },
    { id: "Birds", label: "Birds", subLabel: "Avian Species", icon: faDove, color: "#0284c7", stats: { world: "10,000+", sl: "492", endemic: "34" } },
    { id: "Reptiles", label: "Reptiles", subLabel: "Scaled Tetrapods", icon: faHandLizard, color: "#b91c1c", stats: { world: "10,200+", sl: "209", endemic: "124" } },
    { id: "Amphibians", label: "Amphibians", subLabel: "Dual Environments", icon: faFrog, color: "#16a34a", stats: { world: "7,400+", sl: "121", endemic: "105" } },
    { id: "Fish", label: "Fish", subLabel: "Aquatic Vertebrates", icon: faFish, color: "#0891b2", stats: { world: "33,100+", sl: "1,150+", endemic: "64" } }
];
export const endemismStats = [
    { label: "Amphibians", pct: "87%", icon: faFrog },
    { label: "Reptiles", pct: "59%", icon: faHandLizard },
    { label: "Molluscs", pct: "41%", icon: faCloud },
    { label: "Fish", pct: "25%", icon: faFish },
    { label: "Flowering", pct: "28%", icon: faLeaf },
    { label: "Mammals", pct: "17%", icon: faPaw },
    { label: "Birds", pct: "7%", icon: faDove }
];

export const iucnCategories = [
    {
        code: "EX",
        name: "Extinct",
        color: "#000000",
        textColor: "#ff4444",
        desc: "No reasonable doubt that the last individual has died.",
        longDesc: "A taxon is Extinct when there is no reasonable doubt that the last individual has died. A taxon is presumed Extinct when exhaustive surveys in known and/or expected habitat have failed to record an individual.",
        criteria: "Exhaustive surveys in known and/or expected habitat, at appropriate times (diurnal, seasonal, annual), throughout its historic range have failed to record an individual.",
        implication: "Indicates a permanent loss of biodiversity. Focus shifts to preventing similar losses in related species or ecosystems."
    },
    {
        code: "EW",
        name: "Extinct in the Wild",
        color: "#000000",
        textColor: "#ffffff",
        desc: "Known only to survive in cultivation or captivity.",
        longDesc: "A taxon is Extinct in the Wild when it is known only to survive in cultivation, in captivity or as a naturalized population (or populations) well outside the past range.",
        criteria: "Exhaustive surveys in known and/or expected habitat have failed to record an individual. Only survives in controlled environments.",
        implication: "Requires intensive ex-situ conservation and potentially reintroduction programs to restore wild populations."
    },
    {
        code: "CR",
        name: "Critically Endangered",
        color: "#e11d48",
        textColor: "#ffffff",
        desc: "Facing an extremely high risk of extinction in the wild.",
        longDesc: "A taxon is Critically Endangered when the best available evidence indicates that it meets any of the criteria A to E for Critically Endangered, and it is therefore considered to be facing an extremely high risk of extinction in the wild.",
        criteria: "Population reduction of ≥90% over 10 years, or population size <50 mature individuals.",
        implication: "Urgent, immediate action is required. Often involves habitat protection, legal safeguards, and population management."
    },
    {
        code: "EN",
        name: "Endangered",
        color: "#f97316",
        textColor: "#ffffff",
        desc: "Facing a very high risk of extinction in the wild.",
        longDesc: "A taxon is Endangered when the best available evidence indicates that it meets any of the criteria A to E for Endangered, and it is therefore considered to be facing a very high risk of extinction in the wild.",
        criteria: "Population reduction of ≥70% over 10 years, or population size <250 mature individuals.",
        implication: "High priority for conservation. Efforts focus on mitigating primary threats like habitat loss or poaching."
    },
    {
        code: "VU",
        name: "Vulnerable",
        color: "#eab308",
        textColor: "#ffffff",
        desc: "Facing a high risk of extinction in the wild.",
        longDesc: "A taxon is Vulnerable when the best available evidence indicates that it meets any of the criteria A to E for Vulnerable, and it is therefore considered to be facing a high risk of extinction in the wild.",
        criteria: "Population reduction of ≥50% over 10 years, or population size <1,000 mature individuals.",
        implication: "Species is at risk. Monitoring and preemptive conservation measures are necessary to prevent further decline."
    },
    {
        code: "NT",
        name: "Near Threatened",
        color: "#4ade80",
        textColor: "#ffffff",
        desc: "Close to qualifying for a threatened category.",
        longDesc: "A taxon is Near Threatened when it has been evaluated against the criteria but does not qualify for Critically Endangered, Endangered or Vulnerable now, but is close to qualifying for or is likely to qualify for a threatened category in the near future.",
        criteria: "Close to meeting the thresholds for Vulnerable. Often show a declining trend.",
        implication: "Requires ongoing monitoring and habitat management to ensure it doesn't move into a threatened category."
    },
    {
        code: "LC",
        name: "Least Concern",
        color: "#16a34a",
        textColor: "#ffffff",
        desc: "Widespread and abundant taxa.",
        longDesc: "A taxon is Least Concern when it has been evaluated against the criteria and does not qualify for Critically Endangered, Endangered, Vulnerable or Near Threatened. Widespread and abundant taxa are included in this category.",
        criteria: "Stable populations with no significant threats. Does not meet any of the threatened criteria.",
        implication: "No immediate conservation action required, though broad-scale ecosystem health monitoring is still valuable."
    },
    {
        code: "DD",
        name: "Data Deficient",
        color: "#94a3b8",
        textColor: "#ffffff",
        desc: "Inadequate information to make an assessment.",
        longDesc: "A taxon is Data Deficient when there is inadequate information to make a direct, or indirect, assessment of its risk of extinction based on its distribution and/or population status.",
        criteria: "Lack of data on population trends, distribution, or specific threats.",
        implication: "High priority for research and field surveys to gather the data necessary for a formal assessment."
    }
];
